export const COMPONENT_NAME = "settings-market-test-question";
